<template>
  <div class="modal__no-access">
    <img src="@/assets/ticket.svg" alt="ticket" class="modal__no-access__ticket">
    <h3>{{$t('modal.noAccessGame.legend_1')}}<br>
      {{$t('modal.noAccessGame.legend_2')}}</h3>
    <button class="modal__no-access__action" @click.prevent="exitGame">{{$t('modal.noAccessGame.action')}}</button>
  </div>
</template>
<script>
import persistentData from '@/plugins/persistentData'

export default {
  props: {
    closeModal: Function
  },
  methods: {
    exitGame() {
      this.$store.dispatch('closeModal')
      const dataGame = persistentData.getData(`game-${this.$route.params.id}`, true)
      
      if ( dataGame ) {
        this.$store.dispatch('destroyGameStat')
        this.$store.dispatch('destroyUserIsInGame')
        persistentData.removeData(`game-${this.$route.params.id}`)
        this.$router.push('/home/games')
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/_variables';

.modal__no-access {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  max-width: 400px;
  background: $white;
  height: 260px;
  width: 100%;
  border-radius: $redondeadobig;
  margin: 0 $margin-kilo;
  position: relative;

  h3 {
    padding: $margin-kilo;
    max-width: 240px;
    width: 100%;
    text-align: center;
  }

  &__ticket {
    height: 50px;
  }

  &__action {
    width: 100%;
    background: $yellow;
    color: $white;
    padding: $margin-base;
    margin-top: $margin-mega;
    text-transform: uppercase;
    font-weight: 700;
    border-radius: 0 0 $redondeadobig $redondeadobig;
    z-index: 2;
    border-top: 1px solid $white;
    position: absolute;
    bottom: -8px;
  }
}
</style>